export default "//yastatic.net/s3/distribution/pythia/frontend/_/e3b65c09ff255c1840611b9827d17013.png";